
	        <div class="group relative flex h-full w-full min-w-0 flex-col overflow-visible rounded-[28px] border border-[color:var(--border)] bg-[color:var(--card)] transition-all duration-300 hover:shadow-lg">
	            <a [routerLink]="detailLink" queryParamsHandling="preserve" class="block">
		                <div class="relative w-full aspect-video overflow-hidden bg-[color:var(--muted)] flex items-center justify-center rounded-t-[24px]">
	                    <ng-container *ngIf="mainImage(property) as hero; else placeholder">
                            <div *ngIf="!isImageLoaded(property)" class="absolute inset-0 animate-pulse bg-[color:var(--hover)]"></div>
	                        <img
	                            [src]="hero"
                                (load)="onImageLoad(property)"
	                            (error)="handleImageError(property, hero)"
	                            [alt]="property.title || 'Property image'"
	                            class="absolute inset-0 block h-full w-full object-cover transition-all duration-300 group-hover:scale-105"
                                [class.opacity-0]="!isImageLoaded(property)"
                                [class.opacity-100]="isImageLoaded(property)"
	                        />
	                    </ng-container>
	                    <ng-template #placeholder>
	                        <div class="absolute inset-0 flex items-center justify-center">
	                            <lucide-icon name="building-2" class="h-24 w-24 text-[color:var(--hover-strong)]"></lucide-icon>
	                        </div>
	                    </ng-template>
	
	                    <div class="absolute top-4 left-4 flex flex-wrap items-center gap-2">
	                        <span *ngIf="showStatusBadge" class="rounded-full border px-3 py-1.5 text-xs font-semibold shadow-lg"
	                              [ngClass]="statusMeta.className">
	                            {{ statusMeta.label }}
	                        </span>
	                        <span *ngIf="hasDiscount" class="bg-emerald-500/90 text-white text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg">
	                            -{{ property.discountRate }}%
	                        </span>
	                    </div>

                    <div class="absolute top-4 right-4 flex flex-col items-end gap-2">
                        <ng-container *ngFor="let badge of developmentBadgePills">
                            <span
                                class="max-w-[14rem] truncate rounded-full text-xs font-semibold px-3 py-1.5 shadow-lg border"
                                [ngClass]="badge.className"
                                [title]="badge.title"
                            >
                                {{ badge.label }}
                            </span>
                        </ng-container>
                    </div>

	                    <div class="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 via-black/25 to-transparent p-4 sm:p-6">
	                        <div class="space-y-3">
	                            <div class="space-y-1">
	                                <p class="text-[11px] font-semibold uppercase tracking-[0.18em] text-white/70">Price</p>
	                                <p class="text-2xl sm:text-3xl font-bold leading-tight text-white tabular-nums">
	                                    <ng-container *ngIf="formattedPriceParts as priceParts; else priceFallback">
	                                        <span class="mr-2 text-sm sm:text-base font-semibold text-white/80">{{ priceParts.currency }}</span>
	                                        <span class="whitespace-nowrap">{{ priceParts.amount }}</span>
	                                    </ng-container>
	                                    <ng-template #priceFallback>
	                                        {{ formattedPrice || 'Price on request' }}
	                                    </ng-template>
	                                </p>
	                            </div>
	                            <div class="flex min-w-0 items-center gap-4 text-sm sm:text-base text-white/90">
	                                <div *ngIf="property.unitNumber" class="inline-flex items-center gap-2 min-w-0">
	                                    <lucide-icon name="home" class="h-5 w-5 text-white/80 shrink-0"></lucide-icon>
	                                    <span class="font-semibold truncate min-w-0">Unit {{ property.unitNumber }}</span>
	                                </div>
		                                <div *ngIf="floorDisplayLabel as floorDisplay" class="inline-flex items-center gap-2 min-w-0">
		                                    <svg width="64" height="64" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-white/80 shrink-0" aria-hidden="true">
		                                        <path d="M2 2h3v3h3v3h3v3h3v3H2z" fill="none" stroke="currentColor" stroke-width="1" shape-rendering="crispEdges" />
		                                    </svg>
		                                    <span class="font-semibold truncate min-w-0">{{ floorDisplay }}</span>
		                                </div>
	                                <div *ngIf="countryLabel" class="inline-flex items-center gap-2 min-w-0 flex-1 justify-end">
	                                    <lucide-icon name="map-pin" class="h-5 w-5 text-white/80 shrink-0"></lucide-icon>
	                                    <span class="font-semibold truncate min-w-0">{{ countryLabel }}</span>
	                                </div>
	                            </div>
	                        </div>
	                    </div>
		                </div>
		            </a>

            <div class="flex flex-1 flex-col p-6 gap-4">
                <div class="flex flex-1 flex-col gap-3">
                    <div
                        class="block flex-1 min-w-0 space-y-3 group cursor-pointer"
                        role="link"
                        tabindex="0"
                        (click)="goToDetail()"
                        (keydown.enter)="goToDetail()"
                    >
                        <h3 class="text-lg font-semibold text-[color:var(--foreground)] line-clamp-2 group-hover:text-[color:var(--primary)] transition-colors min-h-[3.5rem]">
                            {{ property.title }}
                        </h3>

                        <a
                            *ngIf="locationLabel && locationMapLink"
                            [href]="locationMapLink"
                            target="_blank"
                            rel="noreferrer"
	                            class="flex w-full min-w-0 items-center gap-2 text-sm text-[color:var(--muted-foreground)] hover:text-[color:var(--primary)]"
                            (click)="$event.stopPropagation()"
                        >
                            <lucide-icon name="map-pin" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
	                            <span class="min-w-0 flex-1 truncate">{{ locationLabel }}</span>
                            <lucide-icon name="external-link" class="h-3.5 w-3.5 opacity-80"></lucide-icon>
                        </a>

                        <p *ngIf="property.tagLine" class="text-sm text-[color:var(--text-subtle)] line-clamp-1">
                            {{ property.tagLine }}
                        </p>

                        <div *ngIf="property.description" class="space-y-1">
                            <p class="text-[11px] font-semibold uppercase tracking-wide text-[color:var(--text-subtle)]">Overview</p>
                            <p class="text-sm leading-relaxed text-[color:var(--muted-foreground)] line-clamp-2">
                                {{ sanitizedDescription }}
                            </p>
                        </div>

		                        <div class="mt-auto flex flex-wrap items-center gap-x-4 gap-y-2 border-t border-[color:var(--border)] pt-3 text-xs font-medium text-[color:var(--muted-foreground)]">
		                            <div *ngIf="property.bedrooms !== null && property.bedrooms !== undefined" class="inline-flex items-center gap-1.5">
		                                <lucide-icon name="bedroom" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
		                                <span class="whitespace-nowrap">{{ property.bedrooms }}</span>
		                            </div>
			                            <div *ngIf="property.bathrooms !== null && property.bathrooms !== undefined" class="inline-flex items-center gap-1.5">
			                                <lucide-icon name="bath" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
			                                <span class="whitespace-nowrap">{{ property.bathrooms }}</span>
			                            </div>
	                            <div *ngIf="property.bua || property.area" class="inline-flex items-center gap-1.5">
	                                <lucide-icon name="maximize-2" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
	                                <span class="whitespace-nowrap">{{ property.bua || property.area }}{{ displayAreaUom }}</span>
	                            </div>
                            <div *ngIf="floorIconLabel" class="inline-flex items-center gap-1.5">
                                <svg width="64" height="64" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-[color:var(--text-subtle)]" aria-hidden="true">
                                    <path d="M2 2h3v3h3v3h3v3h3v3H2z" fill="none" stroke="currentColor" stroke-width="1" shape-rendering="crispEdges" />
                                </svg>
                                <span class="whitespace-nowrap">{{ floorIconLabel }}</span>
                            </div>
	                            <div *ngIf="pricePerSqm" class="inline-flex items-center gap-1.5">
	                                <lucide-icon name="circle-dollar-sign" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
	                                <span class="whitespace-nowrap">{{ pricePerSqm }}/{{ displayAreaUom }}</span>
	                            </div>
		                            <div *ngIf="furnishLabel && !isFullyFurnished" class="inline-flex items-center gap-1.5">
		                                <lucide-icon name="arrow-up-down" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
		                                <span class="whitespace-nowrap">{{ furnishLabel }}</span>
		                            </div>
                            <div *ngIf="finishingLabel" class="inline-flex items-center gap-1.5">
                                <lucide-icon name="diamond" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
                                <span class="whitespace-nowrap">{{ finishingLabel }}</span>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="primaryPlanDisplay as snapshot">
                        <div class="relative rounded-2xl border border-[color:var(--border)] bg-[color:var(--muted)] px-3.5 py-3 text-[color:var(--foreground)] space-y-2.5 overflow-visible hidden sm:block">
                            <div class="flex items-center justify-between gap-2">
                                <div class="flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.15em] text-[color:var(--text-subtle)]">
                                    <lucide-icon name="wallet" class="h-3.5 w-3.5 text-[color:var(--accent)]"></lucide-icon>
                                    Payment Snapshot
                                </div>
                                <div class="rounded-full border border-[color:var(--border)] bg-[color:var(--card)] px-2.5 py-0.5 text-[10px] font-semibold text-[color:var(--muted-foreground)]">
                                    {{ snapshot.label }}
                                </div>
                            </div>

                            <div class="flex items-stretch rounded-xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--card)]">
                                <div class="flex-1 px-3 py-2.5 min-w-0">
                                    <p class="text-[10px] font-semibold uppercase tracking-wide text-[color:var(--text-subtle)]">Down Payment</p>
                                    <p class="mt-0.5 text-sm font-bold leading-tight text-[color:var(--foreground)] tabular-nums truncate">
                                        {{ snapshot.down ?? '—' }}
                                    </p>
                                    <p *ngIf="snapshot.price" class="mt-0.5 text-[11px] text-[color:var(--text-subtle)] truncate">
                                        {{ snapshot.price }} public
                                    </p>
                                    <p *ngIf="snapshot.reserve" class="text-[11px] text-[color:var(--text-subtle)] truncate">
                                        Reserve {{ snapshot.reserve }}
                                    </p>
                                </div>
                                <div class="w-px bg-[color:var(--border)] shrink-0"></div>
                                <div class="flex-1 px-3 py-2.5 min-w-0">
                                    <p class="text-[10px] font-semibold uppercase tracking-wide text-[color:var(--text-subtle)]">Installments</p>
                                    <p class="mt-0.5 text-sm font-bold leading-tight text-[color:var(--foreground)] tabular-nums truncate">
                                        {{ snapshot.installment ?? '—' }}
                                    </p>
                                    <div class="mt-0.5 text-[11px] text-[color:var(--text-subtle)]">
                                        <p *ngIf="snapshot.cycleDescription" class="truncate">{{ snapshot.cycleDescription }}</p>
                                        <p *ngIf="snapshot.installmentsCount" class="truncate">{{ snapshot.installmentsCount }}</p>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="additionalPlans.length" class="relative flex flex-wrap items-center justify-between gap-2">
                                <p class="text-[11px] text-[color:var(--text-subtle)]">
                                    {{ additionalPlans.length }} more plan{{ additionalPlans.length > 1 ? 's' : '' }} available
                                </p>
                                <div class="relative" (click)="$event.stopPropagation()">
                                    <button
                                        type="button"
                                        class="inline-flex items-center gap-1.5 rounded-full border border-[color:var(--border)] bg-[color:var(--card)] px-2.5 py-1 text-[11px] font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
                                        (click)="togglePlans($event)"
                                    >
                                        <lucide-icon name="plus" class="h-3 w-3"></lucide-icon>
                                        View plans
                                    </button>
                                    <div
                                        *ngIf="showPlans"
                                        class="absolute right-0 top-full z-30 mt-2 w-72 rounded-xl border border-[color:var(--border)] bg-[color:var(--popover)] text-[color:var(--popover-foreground)] p-4 shadow-2xl space-y-3"
                                    >
                                        <p class="text-[10px] font-semibold uppercase tracking-wide text-[color:var(--text-subtle)]">Additional payment plans</p>
                                        <div *ngFor="let plan of additionalPlans" class="rounded-lg border border-[color:var(--border)] bg-[color:var(--muted)] p-3 space-y-1">
                                            <p class="text-[10px] font-semibold uppercase tracking-wide text-[color:var(--text-subtle)]">{{ plan.label }}</p>
                                            <p class="text-sm font-bold leading-tight break-words tabular-nums">{{ plan.installment ?? '—' }}</p>
                                            <div class="text-[11px] text-[color:var(--text-subtle)] space-y-0.5 break-words">
                                                <p *ngIf="plan.cycleDescription">{{ plan.cycleDescription }}</p>
                                                <p *ngIf="plan.installmentsCount">{{ plan.installmentsCount }}</p>
                                                <p *ngIf="plan.price">{{ plan.price }} public</p>
                                                <p *ngIf="plan.down">Down {{ plan.down }}</p>
                                                <p *ngIf="plan.reserve">Reserve {{ plan.reserve }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="sm:hidden rounded-xl border border-[color:var(--border)] bg-[color:var(--muted)] p-3 text-[color:var(--foreground)] space-y-2">
                            <div class="flex items-center justify-between gap-2">
                                <span class="text-[11px] font-semibold uppercase tracking-[0.12em] text-[color:var(--text-subtle)]">Payment</span>
                                <span class="rounded-full border border-[color:var(--border)] bg-[color:var(--card)] px-2 py-0.5 text-[11px] font-semibold text-[color:var(--muted-foreground)]">{{ snapshot.label }}</span>
                            </div>
                            <div class="grid grid-cols-2 gap-2 text-xs text-[color:var(--muted-foreground)]">
                                <div class="space-y-0.5">
                                    <p class="text-[11px] text-[color:var(--text-subtle)] uppercase">Down</p>
                                    <p class="font-semibold leading-tight break-words text-[color:var(--foreground)]">{{ snapshot.down ?? '—' }}</p>
                                </div>
                                <div class="space-y-0.5">
                                    <p class="text-[11px] text-[color:var(--text-subtle)] uppercase">Installment</p>
                                    <p class="font-semibold leading-tight break-words text-[color:var(--foreground)]">{{ snapshot.installment ?? '—' }}</p>
                                </div>
                                <div class="space-y-0.5" *ngIf="snapshot.reserve">
                                    <p class="text-[11px] text-[color:var(--text-subtle)] uppercase">Reserve</p>
                                    <p class="font-semibold leading-tight break-words text-[color:var(--foreground)]">{{ snapshot.reserve }}</p>
                                </div>
                                <div class="space-y-0.5" *ngIf="snapshot.price">
                                    <p class="text-[11px] text-[color:var(--text-subtle)] uppercase">Public price</p>
                                    <p class="font-semibold leading-tight break-words text-[color:var(--foreground)]">{{ snapshot.price }}</p>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div *ngIf="canEditStatus" class="rounded-2xl border border-[color:var(--border)] bg-[color:var(--muted)] p-3">
                    <label class="flex items-center gap-2 text-sm text-[color:var(--muted-foreground)]" (click)="$event.stopPropagation()">
                        <lucide-icon name="badge-check" class="h-4 w-4 text-[color:var(--text-subtle)]"></lucide-icon>
                        <span class="font-semibold">Status</span>
                        <select
                            class="ml-auto rounded-lg border border-[color:var(--input)] bg-[color:var(--card)] px-3 py-2 text-sm font-semibold text-[color:var(--foreground)] focus:border-[color:var(--ring)] focus:outline-none disabled:opacity-60"
                            [disabled]="updatingStatus"
                            [ngModel]="statusEditValue"
                            (click)="$event.stopPropagation()"
                            (change)="changePropertyStatus($any($event.target).value, $event)"
                        >
                            <option *ngFor="let option of propertyStatusOptions" [value]="option.value">{{ option.label }}</option>
                        </select>
                    </label>
                </div>

	                <div *ngIf="brochureFileId || masterPlanFileId || brochureLink || masterPlanLink" class="flex flex-wrap gap-2">
		                    <button
		                        *ngIf="brochureFileId || brochureLink"
		                        type="button"
		                        class="inline-flex flex-1 items-center justify-center gap-2 rounded-md border border-[color:var(--border)] bg-[color:var(--card)] px-3 py-2 text-sm font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
		                        (click)="openDocument('brochure', $event)"
		                    >
		                        <lucide-icon name="file-text" class="h-4 w-4"></lucide-icon>
		                        Brochure
		                    </button>
		                    <button
		                        *ngIf="masterPlanFileId || masterPlanLink"
		                        type="button"
		                        class="inline-flex flex-1 items-center justify-center gap-2 rounded-md border border-[color:var(--border)] bg-[color:var(--card)] px-3 py-2 text-sm font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)]"
		                        (click)="openDocument('masterPlan', $event)"
		                    >
		                        <lucide-icon name="map" class="h-4 w-4"></lucide-icon>
	                        Master Plan
	                    </button>
		                </div>
		                <button
		                    *ngIf="detailMode === 'developer' && showSendOfferButton && offersFeatureEnabled"
		                    type="button"
		                    class="inline-flex w-full items-center justify-center gap-2 rounded-md bg-[color:var(--primary)] px-4 py-3 text-sm font-semibold text-[color:var(--primary-foreground)] shadow-sm transition-colors hover:bg-[color:var(--primary-hover)]"
		                    (click)="onSendOffer($event)"
		                >
		                    <lucide-icon name="send" class="h-4 w-4"></lucide-icon>
		                    Property Actions
		                </button>
		                <div *ngIf="detailMode === 'public' && contactOwnerFeatureEnabled" class="pt-2 relative">
	                    <div
	                        *ngIf="showMessageMenu"
	                        class="absolute bottom-full left-0 right-0 mb-2 rounded-2xl border border-[color:var(--border)] bg-[color:var(--card)] p-2 shadow-[0_18px_45px_rgba(0,0,0,0.18)]"
	                        (click)="$event.stopPropagation()"
	                    >
	                        <button
	                            type="button"
	                            class="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-sm font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-60"
	                            (click)="onMessageOption('whatsapp', $event)"
	                            [disabled]="contactLoading && pendingContactAction === 'whatsapp'"
	                        >
	                            <lucide-icon name="send" class="h-4 w-4 text-emerald-500"></lucide-icon>
	                            WhatsApp
	                        </button>
	                        <button
	                            type="button"
	                            class="flex w-full items-center gap-3 rounded-xl px-3 py-2 text-sm font-semibold text-[color:var(--foreground)] transition hover:bg-[color:var(--hover)] disabled:opacity-60"
	                            (click)="onMessageOption('email', $event)"
	                            [disabled]="contactLoading && pendingContactAction === 'email'"
	                        >
	                            <lucide-icon name="mail" class="h-4 w-4 text-[color:var(--accent)]"></lucide-icon>
	                            Email
	                        </button>
	                        <div class="pt-1">
	                            <p *ngIf="contactLoading" class="rounded-xl px-3 py-2 text-sm font-semibold text-[color:var(--muted-foreground)]">Loading contact…</p>
	                            <p
	                                *ngIf="!contactLoading && contactLoaded && !vendorWhatsappNumber && !vendorEmailAddress"
	                                class="rounded-xl px-3 py-2 text-sm text-[color:var(--muted-foreground)]"
	                            >
	                                No contact details provided.
	                            </p>
	                            <p *ngIf="contactError" class="rounded-xl px-3 py-2 text-sm text-red-600">{{ contactError }}</p>
	                        </div>
	                    </div>
	                    <button
	                        type="button"
	                        (click)="toggleMessageMenu($event)"
	                        class="inline-flex w-full items-center justify-center gap-2 rounded-md bg-[color:var(--primary)] py-3 font-semibold text-[color:var(--primary-foreground)] shadow-sm transition-colors hover:bg-[color:var(--primary-hover)]"
	                        [attr.aria-expanded]="showMessageMenu"
	                    >
	                        <lucide-icon name="message-square" class="h-4 w-4"></lucide-icon>
	                        Message
	                    </button>
	                </div>
	            </div>
	        </div>
